import { render, staticRenderFns } from "./screenDisplay.vue?vue&type=template&id=15951504&scoped=true&"
import script from "./screenDisplay.vue?vue&type=script&lang=js&"
export * from "./screenDisplay.vue?vue&type=script&lang=js&"
import style0 from "./screenDisplay.vue?vue&type=style&index=0&id=15951504&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15951504",
  null
  
)

export default component.exports